import React from 'react'
import styled from 'styled'

import { PROGRAM_DESCRIPTION } from 'utils/constants'
import { Card } from './Layout'

interface Props {
  accountName: string
  className?: string
  description?: string
  consumerConfidenceReportURL?: string
}

const Info = ({
  accountName,
  className,
  description,
  consumerConfidenceReportURL
}: Props): JSX.Element => {
  return (
    <InfoCard className={className}>
      <SidebarHeader>About this Program</SidebarHeader>
      <Description>{description || PROGRAM_DESCRIPTION}</Description>
      <SidebarHeader>About this Resource</SidebarHeader>
      <Description>
        {`The resources have been made available by ${accountName} and its commitment to safe drinking water. Please`}{' '}
        <a
          href="https://120water.com/support/"
          rel="noreferrer noopener"
          target="_blank">
          contact 120Water
        </a>{' '}
        for any questions
      </Description>
      <SidebarHeader>Disclaimer</SidebarHeader>
      <Description>
        {`The information provided by 120Water and ${accountName} shall be used for the purpose of providing property owners and residents information regarding their water services. The data is not for commercial, legal, or other use.`}
      </Description>
      <Description>
        {`120Water and ${accountName} cannot guarantee the accuracy of these maps and is not liable for damages of any kind, including but not limited to lost business, lost profits, business interruption, data loss, or other loss that might arise from using this mapping resource and information. 120Water and ${accountName} reserves the right to update or terminate the display of these maps and records at any time.`}
      </Description>
      {consumerConfidenceReportURL && (
        <>
          <SidebarHeader>Additional Resources</SidebarHeader>
          <Description>
            <a
              href={consumerConfidenceReportURL}
              rel="noreferrer noopener"
              target="_blank">
              Consumer Confidence Report
            </a>
          </Description>
        </>
      )}
    </InfoCard>
  )
}

const InfoCard = styled(Card)`
  display: flex;
  flex-direction: column;
`

const SidebarHeader = styled.h6`
  text-align: start;
  padding-left: 20px;
`

const Description = styled.p`
  text-align: start;
  padding-left: 20px;
  padding-right: 20px;
  white-space: pre-line;
`

export default Info
